/**
 * Lightweight video facade.
 *
 * On any [data-video-facade] element (a <button>):
 *   data-provider="youtube|vimeo"  — optional; parsed from data-url if absent
 *   data-id="<video id>"           — optional; parsed from data-url if absent
 *   data-url="<full url or id>"    — fallback source for provider/id parsing
 *   data-has-thumb="true"          — a poster image was already rendered
 *
 * Shows a poster + play button. Only on click (button = keyboard-accessible)
 * does it swap in an autoplaying 16:9 iframe. Dependency-free.
 */
(function () {
  function parseSource(el) {
    var provider = el.getAttribute('data-provider') || '';
    var id = el.getAttribute('data-id') || '';
    if (provider && id) return { provider: provider, id: id };

    var url = (el.getAttribute('data-url') || '').trim();
    if (!url) return { provider: provider, id: id };

    if (url.indexOf('vimeo') !== -1) {
      provider = 'vimeo';
      var vm = url.split('vimeo.com/')[1] || '';
      id = vm.split('?')[0].split('/')[0].replace(/[^0-9]/g, '');
    } else if (url.indexOf('youtu') !== -1) {
      provider = 'youtube';
      var yid = '';
      if (url.indexOf('/embed/') !== -1) {
        yid = url.split('/embed/')[1];
      } else if (url.indexOf('youtu.be/') !== -1) {
        yid = url.split('youtu.be/')[1];
      } else if (url.indexOf('v=') !== -1) {
        yid = url.split('v=')[1];
      }
      id = (yid || '').split('&')[0].split('?')[0];
    } else if (/^[a-zA-Z0-9_-]{11}$/.test(url)) {
      /* Bare YouTube ID */
      provider = 'youtube';
      id = url;
    }

    return { provider: provider, id: id };
  }

  function buildEmbed(provider, id, title) {
    var wrap = document.createElement('span');
    wrap.className = 'vg-card__embed';

    var src;
    if (provider === 'vimeo') {
      src = 'https://player.vimeo.com/video/' + id + '?autoplay=1';
    } else {
      src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
    }

    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', src);
    iframe.setAttribute('title', title || 'Video player');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('width', '100%');
    iframe.setAttribute('height', '100%');
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    iframe.setAttribute('allowfullscreen', '');

    wrap.appendChild(iframe);
    return wrap;
  }

  function init(el) {
    if (el.hasAttribute('data-video-facade-ready')) return;
    el.setAttribute('data-video-facade-ready', 'true');

    var source = parseSource(el);

    /* Auto-poster for YouTube when no thumbnail was provided. */
    if (
      source.provider === 'youtube' &&
      source.id &&
      el.getAttribute('data-has-thumb') !== 'true'
    ) {
      var poster = el.querySelector('.vg-card__poster');
      if (poster && !poster.querySelector('.vg-card__img')) {
        poster.style.backgroundImage =
          "url('https://img.youtube.com/vi/" + source.id + "/hqdefault.jpg')";
      }
    }

    el.addEventListener('click', function () {
      if (el.classList.contains('is-playing')) return;
      if (!source.id) return;

      var title = el.getAttribute('aria-label') || '';
      var embed = buildEmbed(source.provider, source.id, title);

      el.innerHTML = '';
      el.appendChild(embed);
      el.classList.add('is-playing');
      el.setAttribute('aria-pressed', 'true');
    });
  }

  function ready() {
    var els = document.querySelectorAll('[data-video-facade]');
    Array.prototype.forEach.call(els, init);
  }

  if (document.readyState !== 'loading') {
    ready();
  } else {
    document.addEventListener('DOMContentLoaded', ready);
  }
})();
